/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const EmployeeDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 26 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M10,20.8053333 L10,22.6666667 L6,23.6346667 C5.29466667,23.836 4.66666667,24.6013333 4.66666667,25.3333333 L4.66666667,26" />
      <path d="M14,20.8053333 L14,22.6666667 L18,23.6346667 C18.704,23.836 19.344,24.5626667 19.3333333,25.3333333 L19.3333333,26" />
      <ellipse cx="12" cy="17.028" rx="4" ry="4.36266667" />
      <path d="M15.9426667,16.2826667 C15.276,16.9493333 13.3853333,16.8973333 12.6666667,15.56 C11.3333333,16.8933333 9.16666667,16.8933333 8.088,16.132" />
      <polyline points="15.3333333 6 23.3333333 6 23.3333333 31.3333333 0.666666667 31.3333333 0.666666667 6 8.66666667 6" />
      <path d="M15.3333333,10 L8.66666667,10 L8.66666667,4 C8.66666667,2.16666667 10.1666667,0.666666667 12,0.666666667 C13.8333333,0.666666667 15.3333333,2.16666667 15.3333333,4 L15.3333333,10 Z" />
      <path d="M0.666666667,26 L23.3333333,26" />
      <path d="M14.6666667,28.6666667 L20,28.6666667" />
      <path d="M12.6666667,3.99333333 C12.6666667,4.36133333 12.368,4.66 12,4.66 C11.632,4.66 11.3333333,4.36133333 11.3333333,3.99333333 C11.3333333,3.62533333 11.632,3.32666667 12,3.32666667 C12.368,3.32666667 12.6666667,3.62533333 12.6666667,3.99333333 Z" />
    </g>
  </svg>
);

export default EmployeeDetailsIcon;
